// extracted by css-extract-rspack-plugin
export default {"tagContainer":"Ye08tP1t"};